var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"vx-navbar-wrapper navbar-full p-0"},[_c('vs-navbar',{staticClass:"navbar-custom navbar-skelton",class:_vm.navbarClasses,style:(_vm.navbarStyle),attrs:{"color":_vm.navbarColor}},[_c('vs-spacer'),_c('profile-drop-down')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }